export default {
    1001: '业务参数验证错误',
    1002: 'Sign值校验错误',
    1003: 'Token值校验错误',
    1004: '游客账户禁止访问',
    1005: '系统错误',
    1006: 'Token值为空',
    1009: '此号码已绑定其它账号，请更换手机号再尝试。',
    2004: '用户不存在',
    2005: '旧密码错误',
    9001: '发送验证码超过在每日最大限制',
    9002: '验证码错误',
    9100: '八字数据没有找到',
    9101: '分组不为空',
    9300: '百科审核中',
    9301: '批盘审核中',
    9302: '审核通过的不能编辑',
    9303: '提交信息不完整。请填写名人简介及至少10个流年事件。',
    9402: '免费机会不够',
    9401: '已经是解锁状态'
}